import {booleanSchema, RecordSchema, recordSchema, stringSchema} from '@lightweightform/storage';

import {convertDatesAtPathsJs2Json, convertDatesAtPathsJson2Js, sharedSchemas} from '../../shared';
import {pt} from 'oss-registo-kotlin-common-js';

const {bankAccountInfoSchema, makeRegistrationSchema, vatIdSchema, fixedEstablishmentsSchema, OssSchemaType} = sharedSchemas;

const {
  IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR,
} = pt.at.oss.kotlin.manual.validator.common;

const INTERMEDIARY_DATES_PATHS = [
  ['relevantDates', 'registrationReqDate'],
  ['relevantDates', 'forecastStartDate'],
  ['relevantDates', 'msidDecisionDate'],
];
export function convertDatesIntermediaryJson2Js(intermediaryForm) {
  return convertDatesAtPathsJson2Js(INTERMEDIARY_DATES_PATHS)(intermediaryForm);
}
export function convertDatesIntermediaryJs2Json(intermediaryForm) {
  return convertDatesAtPathsJs2Json(INTERMEDIARY_DATES_PATHS)(intermediaryForm);
}

/**
 * Intermediary form schema.
 */
export const intermediarySchema: RecordSchema = makeRegistrationSchema({
  identificationOfBusiness: vatIdSchema(IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR, true),

  currVatId: recordSchema({
    issuingCountry: stringSchema(),
    vatIdNum: stringSchema(),

  }, {isClientOnly: true}),

  bankAccountInfo: bankAccountInfoSchema(false),

  fixedEstablishments: fixedEstablishmentsSchema(true),

}, OssSchemaType.INTERMEDIARY);
